<template>
  <div class="wrapper">
    <el-dialog
      :title="rowId ? '编辑商户' : '新增商户'"
      :visible.sync="showAddOrEdit"
      width="800px"
      :before-close="cancelFun"
    >
      <el-form ref="form" :model="formData" class="wrapper-form" label-width="140px">
        <el-form-item label="商户名称" prop="merchantName" :rules="rules">
          <el-input v-model="formData.merchantName" placeholder="请输入商户名称" size="small"></el-input>
        </el-form-item>
        <el-form-item label="企业名称" :rules="rules">
          <el-input v-model="formData.companyName" placeholder="请输入企业名称" size="small"></el-input>
        </el-form-item>
        <el-form-item label="企业证件号" :rules="rules">
          <el-input v-model="formData.companyIdentity" placeholder="请输入企业证件号" size="small"></el-input>
        </el-form-item>
        <el-form-item label="营业执照" :rules="rules">
          <FileUpload :isMulti="true" :name.sync="formData.companyLicenseList" :url="formData.companyLicenseUrlList"></FileUpload>
        </el-form-item>
        <el-form-item label="企业地址" :rules="rules">
          <el-input v-model="formData.companyAddress" placeholder="请输入企业地址" size="small"></el-input>
        </el-form-item>
        <el-form-item label="法人姓名" :rules="rules">
          <el-input v-model="formData.legalName" placeholder="请输入法人姓名" size="small"></el-input>
        </el-form-item>
        <el-form-item label="法人手机号" :rules="rules">
          <el-input v-model="formData.legalMobile" placeholder="请输入法人手机号" size="small"></el-input>
        </el-form-item>
        <el-form-item label="法人身份证" :rules="rules">
          <el-input v-model="formData.legalIdentity" placeholder="请输入法人身份证" size="small"></el-input>
        </el-form-item>
        <el-form-item :rules="rules" class="idcard-container">
          <FileUpload class="idcard-uploader" :name.sync="formData.legalIdentityFrontImage" :url="formData.legalIdentityFrontImageUrl">
            身份证人像面
          </FileUpload>
          <FileUpload class="idcard-uploader" :name.sync="formData.legalIdentityBackImage" :url="formData.legalIdentityBackImageUrl">
            身份证国徽面
          </FileUpload>
        </el-form-item>
        <el-form-item label="印章ID" :rules="rules">
          <el-input v-model="formData.esignSealId" placeholder="请输入印章ID" size="small"></el-input>
        </el-form-item>
        <el-form-item label="分配比例" :rules="rules">
          <el-input v-model="formData.allocateRate" placeholder="请输入分配比例" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="cancelFun">取 消</el-button>
        <el-button type="primary" size="small" @click="submitFun">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileUpload from '@/components/file-upload/index.vue';
import { addMerchantAPI, getMerchantDetailAPI, editMerchantAPI } from './api';

export default {
  name: 'MerchantAddOrEdit',
  components: { FileUpload },
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      formData: {
        merchantName: '',
        companyName: '',
        companyIdentity: '',
        companyLicenseList: [],
        companyLicenseUrlList: [],
        alipayAccount: '',
        legalName: '',
        legalMobile: '',
        legalEmail: '',
        legalIdentity: '',
        allocateRate: '',
        companyAddress: '',
        esignSealId: '',
      },
      fileList: [],
    }
  },
  mounted() {
    if (this.rowId) this.getMerchantDetail();
  },
  methods: {
    async getMerchantDetail() {
      this.formData = await getMerchantDetailAPI(this.rowId);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    submitFun() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.formData.id) {
            editMerchantAPI(this.formData).then(() => {
              this.$message.success('编辑成功');
              this.$emit("closeDialog", true);
            })
          } else {
            addMerchantAPI(this.formData).then(() => {
              this.$message.success('新增成功');
              this.$emit("closeDialog", true);
            })
          }
        }
      })
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  .wrapper-form {
    max-height: 400px;
    overflow-y: scroll;
  }
  .el-form {
    .el-form-item {
      .el-input {
        width: 500px;
      }
    }
  }
}

.idcard-container {
    /deep/ {
        .el-form-item__content {
            display: flex;
        }
    }

    .idcard-uploader {
        margin-right: 15px;

        /deep/ .el-upload {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 250px;
            height: 150px;
        }
    }
}
</style>
